import script from "./CallLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./CallLogs.vue?vue&type=script&setup=true&lang=js"

import "./CallLogs.vue?vue&type=style&index=0&id=6b626b82&lang=css"

const __exports__ = script;

export default __exports__